"use client";
import { useRouter } from "next/navigation";
import React from "react";
import "./GoBackButton.scss";
import { FiArrowLeft } from "react-icons/fi";
export const GoBackButton = () => {
  const router = useRouter();
  const handleGoBack = () => {
    router.back();
  };
  return (
    <div
      className="flex gap-2 items-center orange-color cursor-pointer hover:underline"
      onClick={handleGoBack}
    >
      <FiArrowLeft className="w-6 h-6" />
      Back
    </div>
  );
};
